// directive
//   <broadcast-card broadcast="broadcast" />

import { differenceFormattedAsDurationLabel } from '../utils/date';

let module = angular.module('app.directives');

module.directive('broadcastCard', ($window, $timeout, $state, $filter, $rootScope) => {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      broadcast: '=',
      showViewCount: '=',
      extraCssClasses: '=',
      preventEdit: '=',
      onSelect: '&',
    },
    controller: BroadcastCardController,
    controllerAs: 'vm',
    template: `
      <!-- go from 4-across to 2-across to 1-across -->
      <div class="broadcast-card {{extraCssClasses}}" style="padding: 10px 0;">
        <div class="col-xs-12">
          <div class="broadcast-card-image-wrapper">
            <div ng-click="vm.select()">
              <div class="broadcast-card-image-preview" ng-style="{ 'background-image': 'url(&quot;'+broadcast.preview+'&quot;)' }"></div>
              <div class="broadcast-card-image-wrapper__message message" ng-if="messageTitle">
                  {{messageTitle}}
                  <div><small>{{messageDetails}}</small></div>
              </div>
              <div class="broadcast-card__stats view-stats">
                <div class="broadcast-card__stats__left pull-left">
                  <span class="broadcast-card__duration">{{duration}}</span>
                  <span class="broadcast-card__views-count" ng-if="(broadcast.total_view_count !== null && showViewCount)">
                    | {{broadcast.total_view_count | number}} view{{ broadcast.total_view_count != 1 ? "s" : "" }}
                  </span>
                </div>
                <div class="broadcast-card__stats__right pull-right">
                  <span ng-if="broadcast.is_ticketed" class="broadcast-card__ticket-label label label-success">\${{broadcast.ticket_price | number:2}} / ticket</span>
                  <span ng-if="broadcast.is_private" class="broadcast-card__private-label label label-danger">Private</span>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
            <div style="position:absolute;left:5px;top:5px" ng-if="broadcast.timeframe == 'current'">
              <label class="label label-danger">LIVE</label>
            </div>
            <div class="broadcast-card__edit-toggle" ng-if="!preventEdit && vm.canEdit">
              <a class="action-link" href="javascript://" ng-click="vm.edit()">
                <i class="fa fa-pencil"></i> Edit
              </a>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="col-xs-12">
          <h4 class="broadcast-card--name broadcast-card__name" style="margin:1rem 0 .4rem; white-space:nowrap; text-overflow:ellipsis; overflow:hidden; line-height:1.2;">
            <a href="javascript://" ng-click="vm.select()">
              {{broadcast.name}}
            </a>
          </h4>
          <div class="broadcast-card--date broadcast-card__date" style="white-space:nowrap; text-overflow:ellipsis; overflow:hidden">
            <date-range start="broadcast.starts_at" end="broadcast.stops_at"></date-range>
          </div>
          <div class="broadcast-card--description broadcast-card__description" style="white-space:nowrap; text-overflow:ellipsis; overflow:hidden">
            <strong><small>{{broadcast.description || '&nbsp;'}}</small></strong>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    `,
    link: (scope, element, attrs) => {
      const { account } = $rootScope;

      scope.$watch('broadcast', (broadcast) => {
        scope.duration = differenceFormattedAsDurationLabel(
          moment(broadcast.starts_at),
          moment(broadcast.stops_at)
        );

        if (!broadcast.preview && broadcast.stream_source == 'imported' && broadcast.recording_id) {
          broadcast.preview = '/img/imported-recording.png';
        }

        // Show message overlay in some special cases. We don't handle all the cases
        // that the actual player widget does, but gets the point across.
        if (
          broadcast.recording_will_purge_at &&
          new Date() > new Date(broadcast.recording_will_purge_at)
        ) {
          scope.messageTitle = 'Recording was deleted.';
        } else if (broadcast.recording_will_purge_at) {
          scope.messageTitle = 'Recording is scheduled for deletion.';
          scope.messageDetails = `Will be deleted on ${$filter('date')(
            broadcast.recording_will_purge_at
          )}`;
        } else if (
          account.storage_policy == 'auto-delete' &&
          broadcast.storage_expires_at &&
          new Date() > new Date(broadcast.storage_expires_at)
        ) {
          scope.messageTitle = 'Recording has expired.';
        } else if (broadcast.recording_requested === false) {
          // This check is explicit, because it could be ''
          if (broadcast.timeframe == 'current') {
            scope.messageTitle = ''; // live badge
          } else if (broadcast.timeframe == 'preroll') {
            scope.messageTitle = 'Starting Soon';
          } else if (broadcast.timeframe == 'past' && broadcast.do_not_record) {
            scope.messageTitle = 'Broadcast was live-only';
          }
        } else if (moment(broadcast.starts_at) > moment()) {
          scope.messageTitle = `Scheduled to begin ${$filter('relativeTime')(broadcast.starts_at)}`;
          scope.messageDetails = $filter('streamSourceName')(broadcast);
        } else if (!broadcast.preview) {
          if (broadcast.stream_source == 'imported' && !broadcast.recording_id) {
            scope.messageTitle = 'Recording is processing';
          } else {
            // (preroll, etc. are handled generally on live view by real player widget)
            scope.messageTitle = 'No recording was found';
          }
        }
      });
    },
  };
});

function BroadcastCardController($scope, $uibModal, $rootScope, $state) {
  'ngInject';
  this.videoLoaded = false;
  this.canEdit = $rootScope.user.can('update', 'broadcast/*');

  this.edit = () => {
    $uibModal
      .open({
        template: require('../pages/events/edit.html'),
        controller: 'EditEventController',
        controllerAs: 'vm',
        resolve: {
          broadcastId: () => $scope.broadcast.id,
          activeTab: () => null,
        },
      })
      .result.then((broadcast) => {
        $scope.broadcast = broadcast;
        $scope.$emit('broadcast:edited', broadcast);
      });
  };

  this.select = () => {
    // XXX: We would love to do something like:
    //   if ($scope.onSelect) { ... } else { ... }
    // here, but Angular _always_ binds $scope.onSelect to _something_, even if it's not bound
    // in the parent controller. So in order to determine if a function _actually_ handled the
    // onSelect event or not, we expect the caller to return true if dealt with, or false if not.
    // And if the function is not bound, it will return undefined, which is falsy.
    let handled = false;
    if ($scope.onSelect) {
      handled = $scope.onSelect({ broadcast: $scope.broadcast });
    }
    if (!handled) {
      window.location.replace(`${window.VUE_DASHBOARD_ROOT}/broadcasts/${$scope.broadcast.id}`);
    }
  };
}

export default module;



// WEBPACK FOOTER //
// ./app/directives/broadcast-card.js